import React from "react";
import { PeekFormControl, PeekFormLabel, PeekTypography, theme } from "@piiqtechnologies/ui-components";
export const ReadOnlyField = ({ label, field }) => {
    return (React.createElement(PeekFormControl, null,
        React.createElement(PeekFormLabel, { sx: { color: theme.palette.grey[400] } }, label),
        React.createElement(PeekTypography, { variant: "h5" }, field.value)));
};
export default ReadOnlyField;
